module.exports = __webpack_public_path__ + "img/del_lago_outside.d284c106.jpg";